import {
  Card,
  Col,
  Row,
  Statistic,
  Tooltip,
  Empty,
  message,
  Avatar,
  Tabs,
  Table,
  Divider,
  Input,
  Button,
  Radio,
  Popconfirm,
} from "antd";
import React, { Component, useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import styles from "./style.module.less";
import * as apis from "@/apis";
import { useDispatch, connect } from "react-redux";
import dayjs from 'dayjs'
import { saveAs } from 'file-saver';
import * as actions from '@/models/banner/actions';
import * as services from '@/models/banner/services';

const Banner = () => {
  const dispatch = useDispatch()
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [queryParams, setQueryParams] = useState({});

  const columns = [
    {
      title: '序号',
      key: '_id',
      width: 60,
      align: 'center',
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    {
      title: '标题',
      width: 200,
      align: 'center',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: '图片地址',
      width: 400,
      key: 'image',
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: 10 }}>
            <Avatar shape="square" size={40} src={item.image} />
          </div>
          <div>{item.image}</div>
        </div>
      )
    },
    {
      title: '跳转地址',
      width: 200,
      align: 'center',
      key: 'url',
      dataIndex: 'url',
    },
    {
      title: '类型',
      width: 160,
      align: 'center',
      key: 'type',
      dataIndex: 'type',
      render: (text, record, idx) => (<div>
        {text == 1 && <span>小程序首页</span>}
      </div>)
    },

    {
      title: '添加时间',
      width: 150,
      render: item => (
        <div>
          {dayjs(item?.createdAt).format('YYYY-MM-DD HH:mm:ss') || '-'}
        </div>
      )
    },
    {
      title: '状态',
      width: 160,
      align: 'center',
      key: 'status',
      dataIndex: 'status',
      render: (text, record, idx) => <div >{record.status ? '上架' : '下架'}</div>
    },
    {
      title: '操作',
      fixed: 'right',
      align: 'center',
      width: 120,
      render: item => {
        return (
          <div>
            <a onClick={showInfoDialog(item)}>修改</a>
            <Divider type="vertical" />
            <Popconfirm
              title="确定删除？"
              placement="topRight"
              onConfirm={() => {
                services.deleteBanner(item._id).then(result => {
                  message.success('删除成功')
                  fetchList()
                }).catch(err => {
                  message.error(err.message || '发生错误')
                })
              }}
            >
              <a>删除</a>
            </Popconfirm>

          </div>
        )
      }
    }
  ]
  const showInfoDialog = useCallback(item => event => {
    event.preventDefault()
    let data
    if (item) {
      data = { ...item, image: [{ url: item.image }] }
    }

    dispatch(actions.showInfoDialog({
      banner: data,
      title: item ? '编辑广告' : '添加广告',
      submitCallback: () => { fetchList() }
    }))
  })

  const fetchList = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || params.offset === 0 ? params.offset : offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setLoading(true)
    setQueryParams(params)

    services
      .queryBannerList(params)
      .then((data) => {
        setItems(data.data || [])
        setTotal(data.total || 0)
      })
      .catch((error) => {
        message.error(error.message || "获取数据失败");
      }).finally(() => {
        setLoading(false)
      })
  }, [queryParams])
  const handleTableChange = (pagination, filters, sorter) => {

    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }
    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetchList(nextQuery)
  }

  useEffect(() => {
    fetchList(

    )
    return () => { }
  }, [])

  return (
    <>
      <div className={styles.blockstyle}>
        <div style={{ marginBottom: 10 }}>
          <Button type="primary" style={{ marginLeft: '10px' }} onClick={showInfoDialog()}>添加广告</Button>
        </div>
        <div>
          <Table
            rowKey="realname"
            size="middle"
            columns={columns}
            dataSource={items}
            onChange={handleTableChange}
            loading={loading}
            scroll={{ x: '100%' }}
            pagination={{
              showQuickJumper: true,
              total: total,
              pageSize: +limit,
              current: Math.floor(offset / +limit) + 1,
              showTotal: total => `共 ${total} 条`
            }}
          ></Table>
        </div>
      </div>
    </>
  );

}

export default connect()(Banner);
